import React from 'react';
import Button from '../../../components/ui/Button';

const FloatingChatButton = ({ onClick, hasNotification = false, isOpen = false }) => {
  return (
    <div className="fixed bottom-6 right-6 z-200">
      <Button
        onClick={onClick}
        variant="default"
        className="w-14 h-14 rounded-full shadow-tier-2 hover:shadow-tier-3 transition-all duration-300 relative"
        title={isOpen ? "Fechar chat" : "Abrir chat com Dai"}
      >
        {isOpen ? (
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-primary-foreground">
            <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-primary-foreground">
            <path 
              fill="currentColor" 
              d="M12 2L3.09 8.26L4 21L12 17L20 21L20.91 8.26L12 2Z"
            />
            <circle cx="12" cy="10" r="2" fill="var(--color-secondary)" />
          </svg>
        )}
      </Button>
      
      {/* Notification Badge */}
      {hasNotification && !isOpen && (
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-secondary rounded-full flex items-center justify-center">
          <span className="text-xs font-medium text-secondary-foreground">1</span>
        </div>
      )}
    </div>
  );
};

export default FloatingChatButton;